import { useActivityBuilderRequest } from 'approot/activity-builder/activity-builder-request.apollo';
import IconRefresh from 'approot/shared/icons/icon-refresh';
import IconTick from 'approot/shared/icons/icon-tick';
import * as Styled from './answer-save-status.style';

const AnswerStatus = ({ isSmall }: { isSmall: boolean }) => {
  const { hasInFlightRequest } = useActivityBuilderRequest();

  return (
    <Styled.AnswerSaveStatus
      $isUpdating={hasInFlightRequest}
      $isSmall={isSmall}
    >
      {hasInFlightRequest ? (
        <>
          <IconRefresh width={14} height={14} />
          <span>Saving...</span>
        </>
      ) : (
        <>
          <IconTick width={12} height={12} />
          <span>Saved</span>
        </>
      )}
    </Styled.AnswerSaveStatus>
  );
};

export const AnswerSaveStatus = ({
  position = 'right',
}: {
  position?: 'left' | 'right';
}) => {
  return (
    <Styled.AnswerSaveStatusOuter $position={position}>
      <AnswerStatus isSmall />
    </Styled.AnswerSaveStatusOuter>
  );
};

export const AnswerSheetSaveStatus = () => {
  return <AnswerStatus isSmall={false} />;
};
